import axios from "axios";
import {
  ALL_CATEGORIES,
  IMAGE_CATEGORIES,
  VIDEO_CATEGORIES,
} from "../constants/galleryCategories";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "",
});

const noCacheGetHeaders = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
};

export function resolveMediaUrl(url) {
  if (!url) return url;
  // If backend is on a different origin/port in dev, make /uploads/* absolute to backend.
  if (typeof url === "string" && url.startsWith("/uploads/")) {
    const base = process.env.REACT_APP_API_BASE_URL;
    if (base) return new URL(url, base).toString();
  }
  return url;
}

export async function fetchGallery({ type, category, page, limit } = {}) {
  const params = {};
  if (type) params.type = type;
  if (category) params.category = category;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  const res = await api.get("/api/gallery", { params, headers: noCacheGetHeaders });
  return res.data;
}

/** @returns {Promise<{ categories: string[], imageCategories: string[], videoCategories: string[] }>} */
export async function fetchCategories() {
  const res = await api.get("/api/gallery/categories", { headers: noCacheGetHeaders });
  const d = res.data || {};
  const hasSplit =
    Array.isArray(d.imageCategories) &&
    d.imageCategories.length > 0 &&
    Array.isArray(d.videoCategories) &&
    d.videoCategories.length > 0;

  if (hasSplit) {
    return {
      categories:
        d.categories ||
        Array.from(new Set([...d.imageCategories, ...d.videoCategories])),
      imageCategories: d.imageCategories,
      videoCategories: d.videoCategories,
    };
  }

  // Older backend: only `categories` — fill image/video lists so admin & gallery UIs work.
  return {
    categories: Array.isArray(d.categories) && d.categories.length ? d.categories : ALL_CATEGORIES,
    imageCategories: IMAGE_CATEGORIES,
    videoCategories: VIDEO_CATEGORIES,
  };
}

export async function login({ username, password }) {
  const res = await api.post("/api/auth/login", { username, password });
  return res.data;
}

export async function logout() {
  const res = await api.post("/api/auth/logout");
  return res.data;
}

function adminConfig(token) {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export async function adminUploadImages({ category, files, token }) {
  const fd = new FormData();
  fd.append("category", category);
  for (const f of files) fd.append("images", f);
  const res = await api.post("/api/admin/gallery/images", fd, adminConfig(token));
  return res.data;
}

export async function adminAddVideo({ category, youtube_url, thumbnailFile, token }) {
  const fd = new FormData();
  fd.append("category", category);
  fd.append("youtube_url", youtube_url);
  if (thumbnailFile) fd.append("thumbnail", thumbnailFile);
  const res = await api.post("/api/admin/gallery/videos", fd, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return res.data;
}

export async function adminDeleteItem({ id, token }) {
  const res = await api.delete(
    `/api/admin/gallery/${encodeURIComponent(id)}`,
    adminConfig(token)
  );
  return res.data;
}

